import {hitAlgolytics} from "@pg-mono/algolytics";

interface IGalleryEvent {
    view_type: string;
    event_type: string;
    site: string;
    site_id: number;
    offer: number;
}

/*
    View event
 */
type IHitOnGalleryViewPayload = Omit<IGalleryEvent, "event_type">;

export const hitGalleryView = (payload: IHitOnGalleryViewPayload) => {
    const eventData: IGalleryEvent = {
        event_type: "gallery_open",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

/*
    Click events
 */
interface IClickGalleryEventData extends IGalleryEvent {
    image_position: number;
}

type IClickGalleryEventPayload = Omit<IClickGalleryEventData, "event_type">;

const clickCollectionName = "gallery_click";

export const hitClickOnGalleryImage = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_on_image",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryNext = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_next",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryPrev = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_previous",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryClose = (payload: Omit<IClickGalleryEventPayload, "image_position">) => {
    const eventData: Omit<IClickGalleryEventData, "image_position"> = {
        event_type: "click_close",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

interface IGalleryEvent {
    view_type: string;
    event_type: string;
    site: string;
    site_id: number;
    offer: number;
}

/*
    View event
 */
type IHitOnGalleryViewPayload = Omit<IGalleryEvent, "event_type">;

export const hitGalleryView = (payload: IHitOnGalleryViewPayload) => {
    const eventData: IGalleryEvent = {
        event_type: "gallery_open",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

/*
    Click events
 */
interface IClickGalleryEventData extends IGalleryEvent {
    image_position: number;
}

type IClickGalleryEventPayload = Omit<IClickGalleryEventData, "event_type">;

const clickCollectionName = "gallery_click";

export const hitClickOnGalleryImage = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_on_image",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryNext = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_next",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryPrev = (payload: IClickGalleryEventPayload) => {
    const eventData: IClickGalleryEventData = {
        event_type: "click_previous",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};

export const hitClickOnGalleryClose = (payload: Omit<IClickGalleryEventPayload, "image_position">) => {
    const eventData: Omit<IClickGalleryEventData, "image_position"> = {
        event_type: "click_close",
        ...payload
    };

    hitAlgolytics(clickCollectionName, eventData);
};
